import React, { useEffect, useState } from 'react'
import { TableFromApiCP } from 'submodules/nerit-framework-ui/common/components/table/TableFromApiCP'
import { TableUtils } from 'submodules/nerit-framework-ui/common/components/table/utils/TableUtils'
import { ButtonGroupCP } from 'submodules/nerit-framework-ui/common/components/button/ButtonGroupCP'
import { ButtonDeleteRecordCP } from 'submodules/nerit-framework-ui/common/components/table/columns/ButtonDeleteRecordCP'
import { TextCP } from 'submodules/nerit-framework-ui/common/components/text/TextCP'
import { AccessControlCP } from 'app/components/access-control/AccessControlCP'
import { PermissionEnum } from 'submodules/nerit-aquatec-sdk/services/auth/authenticate/enums/PermissionEnum'
import { MatrixRequests } from 'submodules/nerit-aquatec-sdk/services/matrix/MatrixRequests'
import { MatrixResponseDTO } from 'submodules/nerit-aquatec-sdk/services/matrix/dtos/responses/MatrixResponseDTO'
import { MatrixSearchRequestDTO } from 'submodules/nerit-aquatec-sdk/services/matrix/dtos/requests/MatrixSearchRequestDTO'
import { ButtonModalMatrixCP } from 'modules/collection-performance/components/matrix/button-modal-matrix/ButtonModalMatrixCP'

interface ICPProps {
    shouldLoadData: number
    filters: MatrixSearchRequestDTO
}

export function TableMatrixCP(props: ICPProps): JSX.Element {

    const [shouldLoadData, setShouldLoadData] = useState<number>(props.shouldLoadData)
    useEffect(() => setShouldLoadData(props.shouldLoadData), [props.shouldLoadData])

    return (
        <TableFromApiCP<MatrixResponseDTO>
            apiConfig={{
                hasPagination: true,
                requestConfigTP: (filtersDto) => MatrixRequests.search({
                    ...filtersDto, ...props.filters,
                }),
            }}
            appearance={{
                showReloadButton: true,
                wrappedOnCard: true,
                showTotalOnHeader: true,
            }}
            shouldLoadData={shouldLoadData}
            columns={[
                {
                    title: '#',
                    render: (text, record) => record.code,
                    align: 'center',
                },
                {
                    title: 'Nome',
                    render: (text, record) => <TextCP text={record.name} size={'small'} copyable={true}/>,
                },
                {
                    title: 'Total de Pontos',
                    render: (text, record) => record.totalLocations,
                    align: 'center',
                },
                {
                    render: (text, record) => (
                        <AccessControlCP permission={PermissionEnum.ROLE_ADMIN}>
                            <ButtonGroupCP mode={'separeted'}>
                                <ButtonModalMatrixCP
                                    onSave={() => setShouldLoadData(TableUtils.getReloadNumber())}
                                    matrix={record}
                                    buttonSize={'small'}
                                />
                                <ButtonDeleteRecordCP
                                    requestConfigTP={() => MatrixRequests.delete(record.code)}
                                    onDelete={() => setShouldLoadData(TableUtils.getReloadNumber())}
                                />
                            </ButtonGroupCP>
                        </AccessControlCP>
                    ),
                },
            ]}
        />
    )
}
